<template>
  <div class="error-500">
    <h1>Server error</h1>
    <p>The server return an error.</p>
  </div>
</template>
<script>
export default {
  name: 'ServerError',
  props: {
    error: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
